/*
 * Round 14: Story views and Story likes as their own columns on the Slots table (the V3 view of
 * V1's main dashboard). Display only - the story module's use of the comment quota is unchanged.
 *
 * Source: the rows of GET /uiapi/slots. Contract coded against (round-14 server):
 *   story_views_today, story_likes_today   today's counts (IGAccStats storyViews/storyLikes
 *                                          DoneThisDaySticky)
 *   story_views_recent, story_likes_recent  optional, V1's column format: "today,yesterday,
 *                                          day before,a day before that" (newest first)
 * A row without either field shows a dash, never 0: an older server that does not send them has
 * not recorded "no story views".
 */
import { parseHistoryCsv } from './slotHistory';

const num = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

/** One kind ('views' | 'likes') for one row -> { today, recent[] } or null when not sent. */
export function storyCount(row, kind) {
  if (!row) return null;
  const today = num(row[`story_${kind}_today`]);
  const recentRaw = row[`story_${kind}_recent`];
  const recent = recentRaw === null || recentRaw === undefined ? [] : parseHistoryCsv(recentRaw);
  if (today === null && recent.length === 0) return null;
  return { today: today !== null ? today : recent[0], recent };
}

/** Tooltip text: "Today 4 - yesterday 7 - 2 days ago 0 - 3 days ago 2". */
export function storyTitle(count, label) {
  if (!count) return `${label}: not reported by this server`;
  const names = ['today', 'yesterday', '2 days ago', '3 days ago'];
  const parts = count.recent.length
    ? count.recent.slice(0, 4).map((n, i) => `${names[i]} ${n}`)
    : [`today ${count.today}`];
  return `${label}: ${parts.join(' - ')}`;
}

/** true when at least one row carries either story field - the columns are drawn only then. */
export function anyStoryData(rows) {
  return Array.isArray(rows) && rows.some((r) => storyCount(r, 'views') || storyCount(r, 'likes'));
}
